import { useState } from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { ShieldCheck, Mail } from 'lucide-react';

export type MFAMethod = 'totp' | 'email';

interface MFAMethodSelectorProps {
  availableMethods: MFAMethod[];
  onSelect: (method: MFAMethod) => void;
  onCancel: () => void;
}

const methodLabels: Record<MFAMethod, { label: string; description: string; icon: React.ReactNode }> = {
  totp: {
    label: 'Authenticator-App',
    description: 'Code aus Google Authenticator, Authy o.ä.',
    icon: <ShieldCheck className="w-6 h-6" />,
  },
  email: {
    label: 'E-Mail-Code',
    description: 'Bestätigungscode per E-Mail erhalten',
    icon: <Mail className="w-6 h-6" />,
  },
};

export default function MFAMethodSelector({ availableMethods, onSelect, onCancel }: MFAMethodSelectorProps) {
  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-4">
      <Card className="w-full max-w-md">
        <CardHeader className="text-center">
          <div className="mx-auto w-12 h-12 bg-primary/10 rounded-full flex items-center justify-center mb-4">
            <ShieldCheck className="w-6 h-6 text-primary" />
          </div>
          <CardTitle className="text-2xl">Verifizierung</CardTitle>
          <CardDescription>
            Wähle deine bevorzugte Verifizierungsmethode
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-3">
          {availableMethods.map((method) => {
            const meta = methodLabels[method];
            return (
              <Button
                key={method}
                variant="outline"
                className="w-full h-auto py-4 px-4 flex items-center gap-4 justify-start"
                onClick={() => onSelect(method)}
              >
                <div className="flex-shrink-0 w-10 h-10 bg-primary/10 rounded-full flex items-center justify-center text-primary">
                  {meta.icon}
                </div>
                <div className="text-left">
                  <div className="font-medium">{meta.label}</div>
                  <div className="text-sm text-muted-foreground font-normal">{meta.description}</div>
                </div>
              </Button>
            );
          })}

          <div className="mt-4 text-center">
            <button
              type="button"
              className="text-sm text-muted-foreground hover:text-primary transition-colors"
              onClick={onCancel}
            >
              Abmelden
            </button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
